export function loadGoogleAnalytics(measurementId) {
  return new Promise((resolve) => {
    // Skip if already loaded for this measurementId
    // (You might track which IDs are already initialized in a global or a React state)
    if (document.getElementById(`ga-script-${measurementId}`)) {
      resolve();
      return;
    }

    // Create the script tag
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    script.id = `ga-script-${measurementId}`;
    script.onload = () => {
      // After loading, configure GA
      if (!window.dataLayer) window.dataLayer = [];
      const gtag = function () {
        window.dataLayer.push(arguments);
      };
      // Use an “init once” approach so you don’t overwrite existing gtag
      if (!window.gtag) window.gtag = gtag;

      window.gtag("js", new Date());
      window.gtag("config", measurementId);
      resolve();
    };

    document.head.appendChild(script);
  });
}

export function loadFacebookPixel(pixelId) {
  // If `fbq` is already defined, we assume the script was already added.
  if (typeof window !== "undefined" && !window.fbq) {
    // Insert the script snippet exactly as recommended by Facebook
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  }

  // Initialize each Pixel ID (if not already initialized)
  if (typeof window.fbq === "function") {
    // Optionally, you could keep track of already-initialized IDs in a global array
    // so you don't double-initialize the same ID.
    window.fbq("init", pixelId);

    // Optionally track an initial page view if it makes sense for your app
    // (some prefer calling this track once a route is determined or user is identified).
    window.fbq("track", "PageView");
  }
}

export function loadTwitterPixel(pixelId) {
  // If twq is already defined, assume the script was injected.
  if (typeof window !== "undefined" && !window.twq) {
    // Insert the script snippet exactly as recommended by Twitter
    !(function (e, t, n, s, u, a) {
      e.twq ||
        ((s = e.twq =
          function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
          }),
        (s.version = "1"),
        (s.queue = []),
        (u = t.createElement(n)),
        (u.async = !0),
        (u.src = "https://static.ads-twitter.com/uwt.js"),
        (a = t.getElementsByTagName(n)[0]),
        a.parentNode.insertBefore(u, a));
    })(window, document, "script");
  }

  // Now, initialize each Pixel ID (if twq exists)
  if (typeof window.twq === "function") {
    // If you wish, you can track which IDs are already initialized
    // to avoid double-initializing the same ID more than once.
    window.twq("init", pixelId);
    // Optionally, track a PageView after initialization
    // (some apps prefer calling twq('track','PageView') later,
    //  once route/user is known, but this is the basic usage).
    window.twq("track", "PageView");
  }
}

export function loadTikTokPixel(pixelId) {
  // If the TikTok Pixel (ttq) isn't defined, inject the script snippet
  if (typeof window !== "undefined" && !window.ttq) {
    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
      ];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
      }
      ttq.instance = function (t) {
        var e = ttq._i[t] || [];
        for (var n = 0; n < ttq.methods.length; n++) {
          ttq.setAndDefer(e, ttq.methods[n]);
        }
        return e;
      };
      ttq.load = function (e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var o = d.createElement("script");
        o.type = "text/javascript";
        o.async = true;
        o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = d.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a);
      };
    })(window, document, "ttq");
  }
  // You could track which IDs were already loaded to avoid duplicates
  window.ttq.load(pixelId);

  // Track a PageView (optional, but often done)
  window.ttq.page();
}

export const trackPageView = () => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
    });

    // tenant specific tracking
    const host = window.location.hostname.split(".")[0];
    if (host === "la-kings") {
      gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-14879299/pageview/lakfa0+standard",
      });
    }
  }
};

export function loadTradeDesk(tradeDeskIds) {
  const advertiserId = tradeDeskIds[0];
  const segmentIds = tradeDeskIds.slice(1);

  return new Promise((resolve) => {
    // Skip if already loaded for this advertiser
    if (document.getElementById(`ttd-script-${advertiserId}`)) {
      resolve();
      return;
    }

    // Create the script tag
    const script = document.createElement("script");
    script.src = "https://js.adsrvr.org/up_loader.1.1.0.js";
    script.async = true;
    script.id = `ttd-script-${advertiserId}`;

    // Define ttd_dom_ready if it doesn't exist
    if (typeof window.ttd_dom_ready !== "function") {
      window.ttd_dom_ready = function (callback) {
        if (document.readyState === "complete") {
          callback();
        } else {
          window.addEventListener("load", callback);
        }
      };
    }

    script.onload = () => {
      // Use ttd_dom_ready as shown in the sample code
      window.ttd_dom_ready(function () {
        if (typeof TTDUniversalPixelApi === "function") {
          const universalPixelApi = new TTDUniversalPixelApi();

          // Initialize with the segment ID as an array and include the base data
          universalPixelApi.init(
            advertiserId,
            segmentIds,
            "https://insight.adsrvr.org/track/up"
          );
        }
        resolve();
      });
    };

    document.head.appendChild(script);
  });
}
